export default __webpack_public_path__ + "locales/lv/SalesDepartmentRequestDialog.json?hash=9bd8373822e87ed8f834f4a7b372753c";